import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const ArrowBack = styled.img`
  height: 20px;
  width: auto;
`;

export const PageTitle = styled.span`
  font-family: BiotifSemiBold;
  font-size: 24px;
`;

export const NavTextLink = styled(NavLink)`
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  gap: 15px;
  align-items: flex-end;
`;

export const RowLabel = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 8px;
`;

export const RowItem = styled.div`
  flex: 1;
`;

export const RadioBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  font-size: 15px;
`;

export const RadioContainer = styled.div`
  display: flex;
  text-align: center;
  gap: 5px;
`;

export const Subtitle = styled.p`
  font: normal normal bold 16px Biotif;
`;

export const StyledRadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  gap: 15px;
  font-size: 15px;
`;

export const StyledRadioButton = styled.div`
  display: flex;
  text-align: center;
  gap: 5px;
`;

export const StyledRadioInput = styled.input``;

export const StyledRadioLabel = styled.label``;
